import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import axios from 'axios';
import { useSelector } from 'react-redux';

const localizer = momentLocalizer(moment);

const initialEvents = [
  // {
  //   title: 'AI Interview - John Doe',
  //   start: new Date(moment().add(1, 'day').set({ hour: 10, minute: 0 })),
  //   end: new Date(moment().add(1, 'day').set({ hour: 11, minute: 0 })),
  // },
  // {
  //   title: 'Mock Interview - Jane Smith',
  //   start: new Date(moment().subtract(1, 'day').set({ hour: 14, minute: 30 })),
  //   end: new Date(moment().subtract(1, 'day').set({ hour: 15, minute: 30 })),
  // },
];

function CalendarView() {
  const { userInfo } = useSelector((state) => state.userInfo);
  const [events, setEvents] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    start: new Date(),
    end: new Date(moment().add(30, 'minutes')),
  });

  const fetchEvents = () => {
    axios
      .get(`https://soapboxapi.megahoot.net/events/mine/${userInfo?.username}`)
      .then((res) => {
        if (res.data && res.data.events) {
          setEvents(
            res.data.events.map((e) => {
              const start = moment(`${e.date} ${e.time}`, 'YYYY-MM-DD HH:mm');
              const end = moment(start).add(30, 'minutes');

              return {
                title: e.title,
                start: new Date(start), // or just `start.toDate()`
                end: new Date(end),
              };
            })
          );
        }
      })
      .catch((err) => console.log(err));
  };

  const handleSelectSlot = ({ start }) => {
    setFormData({
      title: '',
      start,
      end: new Date(moment(start).add(30, 'minutes')),
    });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    setEvents([...events, formData]);
    setOpen(false);
  };

  const handleChange = (field) => (value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
    fetchEvents();
  }, [userInfo]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Calendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            selectable
            onSelectSlot={handleSelectSlot}
            defaultView="week"
            views={['month', 'week', 'day']}
            step={15}
            timeslots={4}
            style={{ height: '200vh' }}
            showMultiDayTimes
            nowIndicator
          />
        </Grid>
      </Grid>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Schedule Interview</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            label="Title"
            value={formData.title}
            onChange={(e) => handleChange('title')(e.target.value)}
          />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              label="Start Time"
              value={formData.start}
              onChange={handleChange('start')}
              renderInput={(params) => (
                <TextField fullWidth margin="dense" {...params} />
              )}
            />
            <DateTimePicker
              label="End Time"
              value={formData.end}
              onChange={handleChange('end')}
              renderInput={(params) => (
                <TextField fullWidth margin="dense" {...params} />
              )}
            />
          </LocalizationProvider>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CalendarView;
